/**
 * Helpers Functions
 */
import moment from 'moment'

// Get moment object of Java Serialized LocalDateTime String
const getDateTimeObject = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z')
}

// Convert Java Serialized LocalTime String To Timestamp
const printTimeStamp = (hhmmss) => {
  if (typeof hhmmss === 'object') {
    hhmmss = `${printTimeElement(hhmmss.hour)}${printTimeElement(hhmmss.minute)}${printTimeElement(hhmmss.second)}`
  }
  return moment(`${hhmmss} +0000`, 'HHmmss Z').format('HH:mm:ss')
}

const printTimeStamp2 = (hhmmss) => {
  if (typeof hhmmss === 'object') {
    hhmmss = `${printTimeElement(hhmmss.hour)}${printTimeElement(hhmmss.minute)}${printTimeElement(hhmmss.second)}`
  }
  return moment(`${hhmmss} +0000`, 'HHmmss Z').format('HH:mm')
}

const printTimeStamp3 = (hhmm) => {
  if (typeof hhmm === 'object') {
    hhmm = `${printTimeElement(hhmm.hour)}${printTimeElement(hhmm.minute)}`
  }
  return moment(`${hhmm} +0000`, 'HHmm Z').format('HH:mm')
}

const convertToHHMM = (time) => {
  if (typeof time === 'object') {
    time = `${printTimeElement(time.hour)}${printTimeElement(time.minute)}`
  }
  return moment(time, 'HH:mm').utc().format('HHmm')
}

const convertToHHMMKst = (time) => {
  if (typeof time === 'object') {
    time = `${printTimeElement(time.hour)}${printTimeElement(time.minute)}`
  }
  return moment(time, 'HH:mm').add(9, 'hours').format('HHmm')
}

const printTimeElement = (timeNum) => {
  return timeNum > 9 ? timeNum : `0${timeNum}`
}

const printTimeStampMessageFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').locale('ja').format('a h:mm')
}

const printTimeStampFromDateTimeWithoutAP = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('HH:mm:ss')
}

const printDateFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY年 MM月 DD日')
}

const printDateFromDateTimeDot = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY.MM.DD')
}

const printTimeStampMMDDHHmmFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('MM-DD HH:mm')
}

const printTimeStampYYYYMMDDFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY-MM-DD')
}

const printTimeStampMMDDHHmmFromKSTDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss').locale('ja').format('MM-DD HH:mm')
}

const printTimeStampYYYYMMDDHHmmFromKSTDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss').locale('ja').format('YYYY-MM-DD LT')
}

const printTimeStampYYYYMMDDFromKSTDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss').locale('ja').format('YYYY-MM-DD')
}

const printTimeStampYYYYMMDDHHmmssFromUTCToKSTDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss}`, 'YYYYMMDDHHmmss Z').add(9, 'hours').format('YYYY-MM-DD HH:mm:ss')
}

const printTimeStampYYYYMMDDHHmmssFromUTCToKSTTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss}`, 'YYYYMMDDHHmmss Z').add(9, 'hours').format('HH:mm')
}

const printTimeStampMMDDFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('MM-DD')
}

const printTimeStampHHmmFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('HH:mm')
}

const printTimeStampYYYYMMDDHHmmFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY-MM-DD HH:mm')
}

const printTimeStampYYYMMDDHHmmADateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY-MM-DD HH:mm A')
}

const printTimeStampMMMDoddFromDateTime = (MMdd) => {
  return moment(`${MMdd} +0000`, 'MMDD Z').locale('ja').format(`MMMDo(dd)`)
}

const convertDateTimeToYYYYMMDDwithHyphen = (yyyyMMddhhmmss) => {
  let formatTime = 'YYYY-MM-DD'
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime)
}

const convertDateTimeToYYYYMMDDwithDot = (yyyyMMddhhmmss) => {
  let formatTime = 'YYYY.MM.DD'
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime)
}

const convertCreateDateToYYYY = (dateTime) => {
  let formatTime = 'YYYY-MM-DD HH:mm'
  return moment(`${dateTime} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime)
}

const convertCreateDateToYYYYMMDDhhmmss = (dateTime) => {
  let formatTime = 'YYYY-MM-DD HH:mm:ss'
  return moment(`${dateTime} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime)
}

const convertDateYyyyMmDd = (dateTime) => {
  let formatTime = 'YYYY-MM-DD'
  if (isNaN(dateTime)) { return dateTime }
  return moment(dateTime, 'YYYYMMDD').format(formatTime)
}

const convertDateYyyyMm = (dateTime) => {
  let formatTime = 'YYYY-MM'
  if (isNaN(dateTime)) { return dateTime }
  return moment(dateTime, 'YYYYMM').format(formatTime)
}

const print1DayToNow = () => {
  const day1 = moment().date(1).format('YYYY-MM-DD')
  const today = moment().format('MM-DD')

  return `${day1} ~ ${today}`
}

const convertHours = (dateTime) => {
  let formatTime = 'HH'
  if (isNaN(dateTime)) { return dateTime }
  return moment(dateTime, 'YYYYMMDDHHmmss').format(formatTime)
}

const timeAgo = (dateTime) => {
  return moment(dateTime, 'YYYYMMDDHHmmss').startOf('minute').fromNow()
}

const getCurrentDateTimeAsFormatted = () => {
  return moment().format('YYYYMMDDHHmmss')
}

const getCurrentUTCDateTimeAsFormatted = () => {
  return moment().utc().format('YYYYMMDDHHmmss')
}

const compareDates = (before) => {
  return moment(before).isBefore(moment.now())
}

const getMinuteDifferenceWithCurrentTime = (YYYYMMDDHHmmss) => {
  return moment().diff(moment(`${YYYYMMDDHHmmss} +0000`, 'YYYYMMDDHHmmss Z'), 'minutes')
}

const convertTimeToMomentType = (YYYYMMDDHHmmss) => {
  return moment(YYYYMMDDHHmmss, 'YYYYMMDDHHmmss')
}

const getDateDiff = (startDate, endDate) => {
  let diffTime = moment(endDate, 'YYYY-MM-DD').diff(moment(startDate, 'YYYY-MM-DD'))
  let duration = moment.duration(diffTime)
  return Math.floor(duration.asDays())
}
/**
 * Text Truncate
 */
const textTruncate = (str, length, ending) => {
  if (length == null) {
    length = 100
  }
  if (ending == null) {
    ending = '...'
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending
  } else {
    return str
  }
}

const numberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * Function to return currenr app layout
 */
const getCurrentAppLayout = (router) => {
  let location = router.history.current.fullPath
  let path = location.split('/')
  return path[1]
}

const findByChatRoomId = (chatRoomList, chatRoomId) => {
  return chatRoomList.find(room => room.chatRoomId === chatRoomId)
}

const findTreeNodeByCode = (element, code) => {
  if (element.data.code === code) {
    return element
  } else if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = findTreeNodeByCode(element.children[i], code)
    }
    return result
  }
  return undefined
}
// 노드 상태 가져오기
const getNodeStates = (element) => {
  let statesArray = []
  pushStates(element, statesArray)
  return statesArray
}
const pushStates = (element, array) => {
  let code = element.data.code
  let states = element.states
  array.push({code: code, states: states})

  if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = pushStates(element.children[i], array)
    }
    return result
  }
  return undefined
}

// 노드 상태 적용하기
const setNodeStates = (element, statesArray) => {
  statesArray.forEach(item => {
    if (element.data.code === item.code) {
      element.states.expanded = item.states.expanded
    }
  })

  if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = setNodeStates(element.children[i], statesArray)
    }
    return result
  }
  return undefined
}

// 템플릿별 validation 체크
const validationTemplate = (element) => {
  if (element.data) {
    if (element.data.scenarioTemplateType === 'IMAGE') {
      let imageContent = element.data.imageContent
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data)
      }
    } else if (element.data.scenarioTemplateType === 'IMAGE_TEXT') {
      let imageContent = element.data.imageContent
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data)
      }
      let textContent = element.data.textContent
      if (textContent === undefined || textContent.title.length === 0 || textContent.description.length === 0) {
        return returnData(element.data)
      }
    } else if (element.data.scenarioTemplateType === 'LIST') {
      let listTemplates = element.data.listTemplates
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data)
      }
    } else if (element.data.scenarioTemplateType === 'IMAGE_LIST') {
      let imageContent = element.data.imageContent
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data)
      }
      let listTemplates = element.data.listTemplates
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data)
      }
    } else if (element.data.scenarioTemplateType === 'IMAGE_LIST_TEXT') {
      let imageContent = element.data.imageContent
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data)
      }
      let listTemplates = element.data.listTemplates
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data)
      }
      let textContent = element.data.textContent
      if (textContent === undefined || textContent.title.length === 0 || textContent.description.length === 0) {
        return returnData(element.data)
      }
    } else if (element.data.scenarioTemplateType === 'LIST_TEXT') {
      let listTemplates = element.data.listTemplates
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data)
      }
      let textContent = element.data.textContent
      if (textContent === undefined || textContent.title.length === 0 || textContent.description.length === 0) {
        return returnData(element.data)
      }
    }
  }

  if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      // 시나리오 이동 외 다른 버튼 (URL, TEL, 상담원연결 등) 은 템플릿 validate 체크를 하지 않는다.
      if (element.children[i].data.templateType === 'LINK_BUTTON') {
        result = validationTemplate(element.children[i])
      }
    }
    return result
  }
  return undefined
}

const returnData = (data) => {
  let result = {}
  // result['text'] = data.text
  result['code'] = data.code
  result['template'] = data.scenarioTemplateType
  return result
}

const findByKey = (list, key) => {
  return list.find(room => room.key === key)
}
const getLastItem = (list) => {
  if (list.length > 0) {
    return list[list.length - 1]
  }
  return undefined
}

const longTextLengthAdjust = (message, length) => {
  return message !== undefined && message.length > length ? message.substring(0, length) + '...' : message || ''
}

const isObjectValid = (targetObject) => {
  return targetObject !== undefined && targetObject !== null && typeof targetObject === 'object'
}

const getFileType = (file) => {
  if (file.type.includes('image/')) {
    return 'PHOTO'
  } else if (file.type.includes('video/')) {
    return 'VIDEO'
  }
  return null
}

const removeChildNodes = (children) => {
  for (let index = 0; index < children.length; index++) {
    let child = children[index]
    child.data.scenarioFlowStatus = 'DELETED'
    if (child.children.length > 0) { removeChildNodes(child.children) }
  }
}

// 시나리오 변경 여부
const isScenarioContentChanged = (element) => {
  if (element.data.scenarioFlowStatus === 'CHANGED') {
    return element
  }

  if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = isScenarioContentChanged(element.children[i])
    }
    return result
  }
  return undefined
}

const isStringValid = (str) => {
  return str !== undefined && str !== null && str.length > 0
}

const isEmailValid = (email) => {
  let rule = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  return rule.test(email)
}

const reduceText = (text, maxLength) => {
  return text.substring(0, maxLength).concat('...')
}

const reduceFileName = (fileName, maxLength) => {
  // 확장자가 없는 경우
  if (!fileName.includes('.')) {
    return reduceText(fileName, maxLength)
  }

  let fileExtension = fileName.split('.').pop()
  let reducedLength = maxLength - fileExtension.length + 2
  if (fileName.length > reducedLength) {
    let reducedText = reduceText(fileName, reducedLength)
    return reducedText.concat(fileExtension)
  }
  return fileName
}

const editExtensionRemove = (fileName) => {
  // 에디터에서 붙는 확장자들
  let extensions = ['vnd', 'msword', 'plain', 'mpeg', 'x', 'related', 'quicktime']
  // 만약 위의 확장자들이 아닐경우 3gp 사용시 붙는 확장자를 기본으로 사용
  let eiditExtension = '3gpp'

  extensions.forEach(e => {
    if (fileName.endsWith(e)) {
      eiditExtension = e
      return false
    }
  })

  return fileName.replace('.' + eiditExtension, '')
}

const charByteSize = (ch) => {
  if (ch == null || ch.length === 0) {
    return 0
  }

  var charCode = ch.charCodeAt(0)

  if (charCode <= 0x00007F) {
    return 1
  } else if (charCode <= 0x0007FF) {
    return 2
  } else if (charCode <= 0x00FFFF) {
    return 2
  } else {
    return 4
  }
}

const reduceByLength = (text, maxLength) => {
  return text.substring(0, maxLength)
}

const cutByLen = (str, maxByte) => {
  let b = 0
  let i = 0
  let c = 1
  for (i = 0; c !== 0;) {
    b += c >> 7 ? 2 : 1
    if (b > maxByte) {
      break
    }
    c = str.charCodeAt(i++)
  }
  return str.substring(0, i)
}

const getByteLength = (s) => {
  if (s == null || s.length === 0) {
    return 0
  }
  var size = 0

  for (var i = 0; i < s.length; i++) {
    size += charByteSize(s.charAt(i))
  }

  return size
}

const textXssFilter = (inputTxt) => {
  // HTML태그 / eval( / document. / javascript: 제거
  return inputTxt.replace(/(<([^>]+)>)/gi, '').replace(/eval\(/gi, '').replace(/document\./gi, '').replace(/javascript:/gi, '')
}

const isSurveyContentChanged = (element) => {
  console.log(element)
  if (element.surveyContentsStatus === 'CHANGED') {
    return element
  }
  return undefined
}

// 카테고리 트리화
const initCategoryElements = (elements) => {
  let data = []
  elements.forEach(e => {
    let node = initCategory(e, data, null)
    if (node) {
      data.push(node)
    }
  })
  // TODO 자식노드까지 data array 에 담기므로.. 우선 parentCode 가 없는 것들만 리턴하도록하고 추후 로직 확인할 것.
  return data.filter(d => !d.data.parentCode)
}
const initCategory = (element, array, parentCode) => {
  let code = getUUID()
  if (parentCode) {
    element['data'] = {categoryId: element.id, status: 'ORIGINAL', code: code, parentCode: parentCode, categoryDescription: element.categoryDescription}
  } else {
    element['data'] = {categoryId: element.id, status: 'ORIGINAL', code: code, categoryDescription: element.categoryDescription}
  }
  array.push(element)

  if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = initCategory(element.children[i], array, code)
    }
    return result
  }
  return undefined
}

const checkOutofRoute = (targetNode, nodes) => {
  let result
  for (let i = 0; i < nodes.length; i++) {
    // 하위에서 최상위로 나온 경우 제한.
    if (nodes[i].data.parentCode) {
      return false
    }
    result = outofRoute(targetNode, nodes[i])
    if (result === false) break
  }
  return result
}

const outofRoute = (targetNode, element) => {
  if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      let childNode = element.children[i]
      if (targetNode.data.code === childNode.data.code) {
        if (targetNode.data.parentCode !== element.data.code) {
          result = false
          return result
        }
      }
      result = outofRoute(targetNode, element.children[i])
    }
    return result
  }
  return undefined
}

const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 3 | 8)
    return v.toString(16)
  })
}

// 삭제되지 않은 카테고리 목록
const findTreeNotDeleted = (treeNodes) => {
  return treeNodes.filter(function f (node) {
    if (node.data.status !== 'DELETED') return true
    if (node.children) {
      return (node.children = node.children.filter(f)).length
    }
  })
}

const deleteWithChildNodes = (element) => {
  element.data.status = 'DELETED'
  if (element.children.length > 0) {
    let result
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = deleteWithChildNodes(element.children[i])
    }
    return result
  }
  return undefined
}

const setCategoryName = (node) => {
  let la = node.text
  let result = categoryName(node, la)
  return result
}

const categoryName = (node, name) => {
  let result
  if (node.parent !== null) {
    result = node.parent.text + '>' + name
    return categoryName(node.parent, result)
  }
  if (node.parent === null) {
    return name
  }
}
const findTreeModelByCode = (element, code) => {
  if (element.data.code === code) {
    return element
  } else if (element.children.length > 0) {
    let result = ''
    for (let i = 0; i < element.children.length; i++) {
      if (!result) {
        result = findTreeNodeByCode(element.children[i], code)
      }
    }
    return result
  }
  return undefined
}

const outCommingPhoneCovert = (phone) => {
  const number = phone.replaceAll('-', '')
  // if (process.env.NODE_ENV === 'production') {
  //   if (number.substr(0, 1) === '9') {
  //     return number
  //   } else {
  //     return '9' + number
  //   }
  // } else {
  //   if (number.substr(0, 2) === '89') {
  //     return number
  //   } else {
  //     return '89' + number
  //   }
  // }

  if (number.substr(0, 1) === '9') {
    return number
  } else {
    return '9' + number
  }
}

const inCommingPhoneCovert = (phone) => {
  const number = phone.replaceAll('-', '')
  // if (process.env.NODE_ENV === 'production') {
  //   if (number.substr(0, 1) === '9') {
  //     return number.substr(1)
  //   } else {
  //     return number
  //   }
  // } else {
  //   if (number.substr(0, 2) === '89') {
  //     return number.substr(2)
  //   } else {
  //     return number
  //   }
  // }

  if (number.substr(0, 1) === '9') {
    return number.substr(1)
  } else {
    return number
  }
}

const isNumberic = (str) => {
  return !isNaN(Number(str))
}

const cutByteLength = (s, len) => {
  if (s === null || s.length === 0) {
    return 0
  }
  let size = 0
  let rIndex = s.length
  for (let i = 0; i < s.length; i++) {
    size += charByteSize(s.charAt(i))
    if (size === len) {
      rIndex = i + 1
      break
    } else if (size > len) {
      rIndex = i
      break
    }
  }
  return s.substring(0, rIndex)
}

const parsingCallAgentStatus = (val) => {
  let byteData = []
  let copyVal = val.slice()
  while (copyVal.length > 0) {
    byteData.push(cutByteLength(copyVal, 27))
    copyVal = copyVal.substr(byteData[byteData.length - 1].length)
    if (copyVal.length === 0) break
  }

  let agentList = []
  byteData.forEach(item => {
    let status = item.substr(item.length - 3, 3).split('')
    if (status[0] === 'W' && status[1] === 'W') {
      let telNumber = item.substr(0, 4)
      let agentId = item.substr(4, item.length - 7).trim()
      agentList.push({id: agentId, name: agentId, workingStatus: '待機', telNumber: telNumber})
    }
  })

  return agentList
}

const parsingCallAgentAllStatus = (val) => {
  let byteData = []
  let copyVal = val.slice()
  while (copyVal.length > 0) {
    byteData.push(cutByteLength(copyVal, 27))
    copyVal = copyVal.substr(byteData[byteData.length - 1].length)
    if (copyVal.length === 0) break
  }

  let agentList = []
  byteData.forEach(item => {
    let status = item.substr(item.length - 3, 3).split('')
    if (status[0] === 'W' && status[1] === 'W') {
      let telNumber = item.substr(0, 4)
      let agentId = item.substr(4, item.length - 7).trim()
      agentList.push({id: agentId, name: agentId, workingStatus: '待機', telNumber: telNumber, sort: 1})
    } else if (status[0] === 'W' && status[1] === 'S') {
      let telNumber = item.substr(0, 4)
      let agentId = item.substr(4, item.length - 7).trim()
      agentList.push({id: agentId, name: agentId, workingStatus: '後処理', telNumber: telNumber, sort: 3})
    } else if (status[0] === 'I' || status[0] === 'O' || status[0] === 'D' || status[0] === 'E' || status[0] === 'H' || status[0] === 'R' || status[0] === 'T' || status[0] === 'C') {
      let telNumber = item.substr(0, 4)
      let agentId = item.substr(4, item.length - 7).trim()
      agentList.push({id: agentId, name: agentId, workingStatus: '通話中', telNumber: telNumber, sort: 2})
    }
  })

  return agentList.sort((a, b) => a.sort - b.sort)
}

const phoneRegExp = (num) => {
  if (num) {
    let startNum = num.substring(0, 2)
    if (startNum === '15' || startNum === '16' || startNum === '18') {
      startNum = num.replace(/(^15.{2}|^16.{2}|^18.{2})([0-9]{4})/, '$1-$2')
    } else {
      startNum = num.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3')
    }
    return startNum
  } else {
    return ''
  }
}
const printDashboardCount = (count) => {
  return count !== 0 ? count + '件' : '-'
}

const checkPassword = (pw, pwCon) => {
  if (!pw || !pwCon) {
    alert('パスワードとパスワードの確認の両方を入力してください。')
    return false
  }

  // 비밀번호 정규식 패턴
  let pwRex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}/g
  let password = pw.replace(/(\s*)/g, '')
  let passwordConfirm = pwCon.replace(/(\s*)/g, '')

  if (!password || password.length < 1 || !passwordConfirm || passwordConfirm.length < 1) {
    alert('パスワードとパスワードの確認の両方を入力してください。')
    return false
  } else if (password !== passwordConfirm) {
    alert('パスワードの入力方法が間違っています。')
    return false
  } else if (!pwRex.test(password)) {
    alert('パスワードは英大文字/小文字/数字/特殊文字の全てを使用して8〜16桁で入力してください。')
    return false
  }
  return true
}
const freezeOff = (object) => {
  return JSON.parse(JSON.stringify(object))
}

const findCallApiUrl = (type) => {
  let url = null
  if (type) {
    url = process.env.CALL_API_URL[type]
  }
  return url
}

const findCallUrl = (type) => {
  let url = null
  switch (type) {
    case 'NEOMECCA_1':
      url = process.env.CALL_URL
      break
    case 'NEOMECCA_2':
      url = process.env.CALL_URL_2
      break
    case 'NEOMECCA_3':
      url = process.env.CALL_URL_3
      break
  }
  return url
}

const findCallWebsocketUrl = (type) => {
  let url = null
  if (type) {
    url = process.env.CTI_WEBSOCKET_URL[type]
  }
  return url
}

const findCallStatusUrl = () => {
  let url = process.env.CALL_STATUS_URL || null
  return url
}
const printDateYearMonthDay = (yyyyMMdd) => {
  return moment(`${yyyyMMdd} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY年 MM月 DD日')
}

export default {
  getDateTimeObject,
  printTimeStamp,
  printTimeStampFromDateTimeWithoutAP,
  printDateFromDateTime,
  printDateFromDateTimeDot,
  printTimeStampMessageFromDateTime,
  printTimeStampMMDDHHmmFromDateTime,
  printTimeStampYYYYMMDDFromDateTime,
  printTimeStampMMDDHHmmFromKSTDateTime,
  printTimeStampYYYYMMDDHHmmFromKSTDateTime,
  printTimeStampYYYYMMDDHHmmFromDateTime,
  printTimeStampYYYYMMDDFromKSTDateTime,
  printTimeStampYYYYMMDDHHmmssFromUTCToKSTDateTime,
  printTimeStampYYYYMMDDHHmmssFromUTCToKSTTime,
  printTimeStampHHmmFromDateTime,
  printTimeStampMMDDFromDateTime,
  printTimeStampYYYMMDDHHmmADateTime,
  printTimeStampMMMDoddFromDateTime,
  convertDateTimeToYYYYMMDDwithHyphen,
  convertDateTimeToYYYYMMDDwithDot,
  convertCreateDateToYYYY,
  convertCreateDateToYYYYMMDDhhmmss,
  convertDateYyyyMmDd,
  convertDateYyyyMm,
  print1DayToNow,
  getMinuteDifferenceWithCurrentTime,
  numberWithCommas,
  textTruncate,
  convertHours,
  getCurrentAppLayout,
  printTimeStamp2,
  findByChatRoomId,
  findByKey,
  getLastItem,
  longTextLengthAdjust,
  isObjectValid,
  isStringValid,
  isEmailValid,
  getFileType,
  timeAgo,
  getCurrentDateTimeAsFormatted,
  getCurrentUTCDateTimeAsFormatted,
  findTreeNodeByCode,
  validationTemplate,
  removeChildNodes,
  isScenarioContentChanged,
  compareDates,
  getNodeStates,
  setNodeStates,
  convertTimeToMomentType,
  reduceText,
  reduceByLength,
  reduceFileName,
  charByteSize,
  cutByLen,
  getByteLength,
  textXssFilter,
  isSurveyContentChanged,
  initCategoryElements,
  findTreeNotDeleted,
  deleteWithChildNodes,
  outofRoute,
  checkOutofRoute,
  setCategoryName,
  findTreeModelByCode,
  editExtensionRemove,
  outCommingPhoneCovert,
  inCommingPhoneCovert,
  isNumberic,
  parsingCallAgentStatus,
  phoneRegExp,
  cutByteLength,
  parsingCallAgentAllStatus,
  printDashboardCount,
  checkPassword,
  freezeOff,
  findCallApiUrl,
  findCallUrl,
  findCallWebsocketUrl,
  findCallStatusUrl,
  getDateDiff,
  printDateYearMonthDay,
  convertToHHMM,
  printTimeStamp3,
  convertToHHMMKst
}



// WEBPACK FOOTER //
// ./src/util/helpers.js